module.exports = __webpack_public_path__ + "img/option_icon.e60fd1c8.svg";